import Vue from "vue";
import Vuex from "vuex";
import Service from "../../../service/api.js";
import router from "../../../router/index.js";
import store from "@/store/store";

const objsModule = {
    namespaced: true,
    state: {
        mappings : []
    },

    mutations: {
        mappings(state, obj) {
            state.mappings = obj;
        },

    },

    actions: {
        mappings({commit}, data) {
            Service.EProtMapping('exp', {}, {})
                .then((response) => {
                    store.commit("EProtMapping/mappings", response.data.data)
                }).catch((err) => {
            });
        },
    },

    getters: {
        mappings(state) {
            return state.mappings;
        },

    },
};
export default objsModule;
